export const base = {

}

export const sully = {
  primary: '#008193',
  secondary: '#a1d315',
  error: '#E04C38',
  classic: '#FFFFFF',
  disabled: '#E2E2E2',
  background: '#F2F2F2',
  text: '#0a484f',
  grey: '#707070',
  success: '#2fbd2f',
}

export const endroitsdecite = {
  primary: '#de4444',
  secondary: '#2c7d8a',
  error: '#E04C38',
  classic: '#FFFFFF',
  disabled: '#E2E2E2',
  background: '#f5ebd9',
  text: '#0a484f',
  grey: '#707070',
  success: '#2fbd2f',
}